import React, { PureComponent } from 'react';
import { FormattedMessage } from 'react-intl';
import { isURL } from 'validator';
import { Label, Input, FormGroup, InputGroup, InputGroupAddon, Button } from 'reactstrap';
import { string, func } from 'prop-types';

class FlowPostbackUrl extends PureComponent {
  static propTypes = {
    url: string.isRequired,
    onUrlChange: func.isRequired,
    onCheckPostback: func.isRequired,
  };

  isValidUrl = (url) => isURL(url);

  render() {
    const { url, onUrlChange, onCheckPostback, theme } = this.props;

    return (
      <FormGroup className="form-group-upper-label">
        <Label for="postback-url">URL</Label>
        <InputGroup>
          <Input
            type="url"
            name="url"
            id="postback-url"
            onChange={({ target }) => {
              onUrlChange({ [target.name]: target.value });
            }}
            value={url}
            placeholder="http://example.com/"
          />
          
          <InputGroupAddon addonType="append">
            <Button
              type="button"
              color="primary"
              size="md"
              onClick={onCheckPostback}
              disabled={!this.isValidUrl(url)}
            >
              <FormattedMessage id="flow.form.postback.check" defaultMessage="Check Postback" />
            </Button>
          </InputGroupAddon>
        </InputGroup>
      </FormGroup>
    );
  }
}

export default FlowPostbackUrl;
